import type { ApPurchaseDocument } from "@/accounts-payable/types";
import {
  formatApZonedDateTime,
  reviewStateMeta,
} from "@/accounts-payable/utils";
import { StatusBadge } from "./shared";
import { useApBusinessTimeZone } from "./use-ap-business-time-zone";

export const ReviewBadge = ({
  document,
}: {
  document: Pick<ApPurchaseDocument, "review_state" | "reviewed_at">;
}) => {
  const timeZone = useApBusinessTimeZone();
  const meta = reviewStateMeta(document.review_state);
  if (!meta) return <span className="text-subtle">–</span>;

  const reviewedAt = formatApZonedDateTime(document.reviewed_at, timeZone);
  return (
    <span title={reviewedAt && `Reviewed ${reviewedAt}`}>
      <StatusBadge meta={meta} quietWhenSettled />
    </span>
  );
};
